<template>
  <div class="map-container">
    <div id="map" ref="map"></div>
  </div>
</template>

<script>
import { mapService } from "@/services/map/mapService";

export default {
  name: "MapView",

  mounted() {
    mapService.init("map");
  },

  beforeDestroy() {
    mapService.destroy();
  }
};
</script>

<style scoped>
.map-container {
  width: 100%;
  height: 100%;
}

#map {
  width: 100%;
  height: 100%;
}
</style>
